import React from "react";
import "../assets/styles/LoginPrompt.css";
import microsoftLogo from "../assets/img/microsoft-logo.svg";

export default function LoginPrompt({ handleLogin }) {
    return (
        <div>
            <h1>Login</h1>
            <button className="login-button microsoft" onClick={handleLogin}>
                <img src={microsoftLogo} alt="Microsoft Logo" className="ms-logo" />
                <span>Login mit Azure AD</span>
            </button>
        </div>
    );
}
